import translate from "src/lib/translate";

const formatRelativeMs = (epochMs: number): string | null => {
  const diffMs = Date.now() - epochMs;
  const diffMin = Math.floor(diffMs / 60_000);
  const diffHr = Math.floor(diffMs / 3_600_000);
  const diffDays = Math.floor(diffMs / 86_400_000);

  if (diffMin < 1) {
    return translate("leapChat.time.justNow");
  }
  if (diffMin < 60) {
    return translate("leapChat.time.minutesAgo", { count: diffMin });
  }
  if (diffHr < 24) {
    return translate("leapChat.time.hoursAgo", { count: diffHr });
  }
  if (diffDays === 1) {
    return translate("leapChat.time.yesterday");
  }
  if (diffDays < 7) {
    return translate("leapChat.time.daysAgo", { count: diffDays });
  }
  return null;
};

export const formatRelativeTime = (dateStr: string): string => {
  const epochMs = new Date(dateStr).getTime();
  const relative = formatRelativeMs(epochMs);
  if (relative) {
    return relative;
  }

  const diffWeeks = Math.floor((Date.now() - epochMs) / 604_800_000);
  if (diffWeeks === 1) {
    return translate("leapChat.time.weeksAgo", { count: 1 });
  }
  return translate("leapChat.time.weeksAgoPlural", { count: diffWeeks });
};
